import React from 'react';
import { Box } from '@mui/material';
import ContentTypeSelector from './ContentTypeSelector';
import StandardContentEditor from './StandardContentEditor';
import HtmlContentEditor from './HtmlContentEditor';
import CustomHtmlContentEditor from './CustomHtmlContentEditor';
import FlippingCardsEditor from './FlippingCardsEditor';
import LabyrinthContentEditor from './LabyrinthContentEditor';
import MemoryGameEditor from './MemoryGameEditor';
import TagCloudEditor from './TagCloudEditor';
import RolePlayGameEditor from './RolePlayGameEditor';
import VideoContentEditor from './VideoContentEditor';

/**
 * Компонент для выбора и отображения редактора контента в зависимости от его типа
 * @param {string} contentType - Тип контента ('standard', 'presentation', 'flippingCards' и т.д.)
 * @param {string} content - Содержимое
 * @param {function} onContentChange - Функция обработки изменения содержимого
 * @param {function} onContentTypeChange - Функция обработки изменения типа контента
 * @param {function} onSwitchToBlocks - Функция для переключения на многоблочный редактор
 */
const ContentTypeEditor = ({
  contentType,
  content,
  onContentChange,
  onContentTypeChange,
  onSwitchToBlocks,
  onSwitchToSingle,
  isMultiBlockMode = false,
}) => {
  
  // Рендерим редактор в зависимости от типа контента
  const renderEditorForType = () => {
    switch (contentType) {
      case 'standard':
        return (
          <StandardContentEditor content={content} onChange={onContentChange} />
        );
      case 'presentation':
      case 'htmlBlock':
        return (
          <HtmlContentEditor content={content} onChange={onContentChange} />
        );
      case 'fullHtml':
        return (
          <CustomHtmlContentEditor content={content} onChange={onContentChange} />
        );
      case 'flippingCards':
        return (
          <FlippingCardsEditor content={content} onChange={onContentChange} />
        );
      case 'labyrinth':
        return (
          <LabyrinthContentEditor
            content={content}
            onChange={onContentChange}
          />
        );
      case 'memoryGame':
        return (
          <MemoryGameEditor content={content} onChange={onContentChange} />
        );
      case 'tagCloud':
        return <TagCloudEditor content={content} onChange={onContentChange} />;
      case 'rolePlayGame':
        return (
          <RolePlayGameEditor content={content} onChange={onContentChange} />
        );
      case 'video':
        return (
          <VideoContentEditor content={content} onChange={onContentChange} />
        );
      default:
        return (
          <StandardContentEditor content={content} onChange={onContentChange} />
        );
    }
  };

  return (
    <Box>
      <ContentTypeSelector
        selectedType={contentType || 'standard'}
        onChange={onContentTypeChange}
        onSwitchToBlocks={onSwitchToBlocks}
        onSwitchToSingle={onSwitchToSingle}
        isMultiBlockMode={isMultiBlockMode}
      />

      {renderEditorForType()}
    </Box>
  );
};

export default ContentTypeEditor;
